import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import './assets/styles/Global.css';
import './assets/styles/MediaQuery.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import UpComing from './Pages/UpComing';
import RegisterForm from './Pages/auth/RegisterForm';
import OtpVerification from './Pages/auth/OtpVerification';
import LoginForm from './Pages/auth/LoginForm';
import { Slide, toast, ToastContainer } from 'react-toastify';
import ForgotPassword from './Pages/auth/ForgotPassword';
import Guide from './Pages/Guide';
import ResetPassword from './Pages/auth/ResetPassword';
import Loader from './components/Loader';
import AuthGaurd from './components/Guards/AuthGaurd';
import UnAuthGaurd from './components/Guards/UnAuthGaurd';
import DashboardPerformance from './Pages/DashboardPerformance';
import { getLocalStorage, getWithToken } from './API/Api';
import NotFound from './Pages/NotFound';
import ThreeDotLoader from './components/ThreeDotLoader';
import AutoResponse from './Pages/AutoResponse';
import Policy from './components/Policy';
import Layout from './components/Layout';
import WidgetChatbot from './Pages/widgets/chatbot/WidgetChatbot';
import MyLeads from './Pages/MyLeads';
import NavTabLayout from './components/NavTabLayout ';
import Subscription from './Pages/subscription/Subscription';
import SubThankyou from './Pages/subscription/SubThankyou';
import { useEffect, useState } from 'react';
import Integrations from './Pages/Integrations.js';
import TrainAgent from './components/TrainAgent.js';
import LeapPage from './Pages/LeapPage.js';
import Settings from './Pages/Settings.js';
import ProtectedRoute from './routes/ProtectedRoute.js';
import SubContext from './contexts/SubContext.js';
import { PATHS, SESSION_PATHS } from './routes/paths.js';
import { getPlanLevel, PLAN_LEVELS } from './API/Constant.js';
import UserProfile from './Pages/UserProfile.js';

function App() {
  const [subscriptionFlag, setSubscriptionFlag] = useState('');
  const [conversionData, setConversionData] = useState('');
  const [updateValue, setUpdateValue] = useState('');
  const [profileDetails, setProfileDetails] = useState('');
  const [apiTokenData, setApiTokenData] = useState('');

  const subscriptionInfo = subscriptionFlag?.user?.subscription ?? null;
  const subscriptionName = subscriptionInfo?.name ?? 'Free';
  const planLevel = getPlanLevel(subscriptionName);

  const isLoggedIn = Boolean(apiTokenData);

  useEffect(() => {
    let token = getLocalStorage('apiToken');
    if (token) {
      const parsedToken = JSON.parse(token);
      setApiTokenData(parsedToken);
      refreshSubscription(parsedToken);
      getConversion(parsedToken);
      getUserProfileDetails(parsedToken);
    }
  }, []);

  // sirf jab updateValue change hoga
  useEffect(() => {
    if (apiTokenData && updateValue) {
      getConversion(apiTokenData);
      setUpdateValue(''); // reset karne ki jagah yaha karo
    }
  }, [updateValue, apiTokenData]);

  const refreshSubscription = async (token = apiTokenData) => {
    try {
      const response = await getWithToken('list_subscription', token);
      if (response?.data) {
        setSubscriptionFlag(response?.data);
      }
    } catch (error) {
      toast.error('Failed to fetch subscription details');
    }
  };

  const getConversion = (token) => {
    getWithToken('get_conversation', token)
      .then((response) => {
        if (response.status === 200) {
          setConversionData(response?.data);
          setUpdateValue('');
        }
      })
      .catch((error) => {
        toast.error('Something went wrong');
      });
  };

  const getUserProfileDetails = (token = apiTokenData) => {
    getWithToken('userprofile/', token)
      .then((response) => {
        if (response.status === 200) {
          setProfileDetails(response);
        }
      })
      .catch((error) => {
        toast.error('Something went wrong');
      });
  };

  const getDefaultRedirect = () => {
    if (!subscriptionFlag?.user) return PATHS.CHATBOT;
    if (subscriptionFlag?.user.subs_id === null) return PATHS.PRICING;
    if (planLevel >= PLAN_LEVELS.Starter) return PATHS.DASHBOARD;
    return PATHS.CHATBOT;
  };

  return (
    <>
      <SubContext.Provider value={{ subscriptionFlag, setUpdateValue, conversionData, refreshSubscription }}>
        <ToastContainer
          position='top-right'
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          transition={Slide}
          pauseOnFocusLoss
          draggable
          pauseOnHover={true}
          theme='colored'
          style={{ zIndex: '99999999' }}
        />
        <BrowserRouter>
          <Routes>
            {!isLoggedIn && <Route path='/' element={<Navigate to='/login' />} />}
            {isLoggedIn && <Route path='/' element={<Navigate to={getDefaultRedirect()} />} />}

            <Route path='/' element={<Layout />}>
              <Route element={<AuthGaurd />}>
                <Route path='/' element={<NavTabLayout />}>
                  {/* Always available */}
                  <Route path={PATHS.CHATBOT} element={<TrainAgent profileDetails={profileDetails} getUserProfileDetails={() => getUserProfileDetails(apiTokenData)} />} />

                  {/* Scale+ → Dashboard */}
                  <Route element={<ProtectedRoute allowed={planLevel >= PLAN_LEVELS.Scale} />}>
                    <Route path={PATHS.DASHBOARD} element={<DashboardPerformance />} />
                  </Route>

                  {/* Growth+ → Leads, Leap, Integrations */}
                  <Route element={<ProtectedRoute allowed={planLevel >= PLAN_LEVELS.Growth} />}>
                    <Route path={PATHS.LEADS} element={<MyLeads />} />
                    <Route path={PATHS.LEAP} element={<LeapPage />} />
                    <Route path={PATHS.INTEGRATIONS} element={<Integrations />} />
                  </Route>

                  <Route path={PATHS.SETTINGS} element={<Settings />} />
                  <Route path={PATHS.USER_PROFILE} element={<UserProfile />} />
                  <Route path={PATHS.PRICING} element={<Subscription />} />
                  <Route path={PATHS.SUBSCRIPTION_THANK_YOU} element={<SubThankyou />} />
                </Route>
                <Route path={PATHS.AUTORESPONSE} element={<AutoResponse />} />
                <Route path={PATHS.UPCOMING} element={<UpComing />} />
                <Route path={PATHS.GUIDE} element={<Guide />} />
              </Route>
            </Route>
            <Route path={PATHS.PREVIEW_CHATBOT} element={<WidgetChatbot />} />
            <Route path={PATHS.POLICY} element={<Policy />} />
            <Route path={PATHS.THREE_DOT_LOADER} exact element={<ThreeDotLoader />} />
            <Route path={PATHS.GENERAL_LOADER} element={<Loader />} />

            <Route element={<UnAuthGaurd />}>
              <Route path={SESSION_PATHS.LOGIN} element={<LoginForm />} />
              <Route path={SESSION_PATHS.REGISTER} element={<RegisterForm />} />
              <Route path={SESSION_PATHS.OTP_VERIFICATION(':type')} element={<OtpVerification />} />
              <Route path={SESSION_PATHS.FORGOT_PASSWORD} element={<ForgotPassword />} />
              <Route path={SESSION_PATHS.RESET_PASSWORD} element={<ResetPassword />} />
            </Route>
            <Route path={PATHS.NOT_FOUND} exact element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </SubContext.Provider>
    </>
  );
}

export default App;
